const VideoIcon = ({
  active,
  width = 18,
  height = 18,
  stroke = '#434750',
}: {
  active?: boolean;
  width?: number;
  height?: number;
  stroke?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.265 10.21H3.105C1.525 10.21 1 9.15998 1 8.10498V3.89498C1 2.31498 1.525 1.78998 3.105 1.78998H6.265C7.845 1.78998 8.37 2.31498 8.37 3.89498V8.10498C8.37 9.68498 7.84 10.21 6.265 10.21Z"
        stroke={active ? '#554688' : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.76012 8.55001L8.37012 7.57501V4.42L9.76012 3.445C10.4401 2.97 11.0001 3.26 11.0001 4.095V7.90501C11.0001 8.74001 10.4401 9.03001 9.76012 8.55001Z"
        stroke={active ? '#554688' : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 5.5C6.16421 5.5 6.5 5.16421 6.5 4.75C6.5 4.33579 6.16421 4 5.75 4C5.33579 4 5 4.33579 5 4.75C5 5.16421 5.33579 5.5 5.75 5.5Z"
        stroke={active ? '#554688' : stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VideoIcon;
